/**
 * One-time reveal of a freshly minted agent token. The raw token is shown
 * exactly once (it is hash-stored server-side and can never be retrieved),
 * so this renders a read-only field plus a copy affordance. Rendered inside
 * a FormModal body on both the My Agents and admin Agents screens.
 */

import { useState } from 'react';
import formStyles from './FormModal.module.css';
import styles from './TokenReveal.module.css';

export function TokenReveal({ token }: { token: string }) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      /* clipboard unavailable — the token is still selectable in the field */
    }
  };

  return (
    <div className={formStyles.field}>
      <span className={formStyles.fieldLabel}>Access token</span>
      <div className={styles.tokenRow}>
        <input
          className={`${formStyles.input} ${styles.tokenInput}`}
          readOnly
          value={token}
          onFocus={(e) => e.currentTarget.select()}
        />
        <button
          type="button"
          className="kos-btn kos-btn-primary"
          onClick={copy}
        >
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <span className={formStyles.fieldHint}>
        Store it in your agent's configuration as a Bearer token.
      </span>
    </div>
  );
}
